export default {
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    }
  },
  beforeCreate() {
    this.$store.dispatch("user/setMode", "template")
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/setMode", "common")
    next()
  }
}
